import React from 'react'

export default function FooterView() {
  return (
    <div>
            <footer id="footer" className="footer dark-background">
    <div className="container">
      <h3 className="sitename">Jesuit Madurai Province Archives</h3>
      <p>Sacred Heart College Shembaganur Kodaikanal - 624 101</p>
      <div className="social-links d-flex justify-content-center">
        {/*<a href=""><i className="bi bi-twitter-x"></i></a>*/}
        <a href="https://www.facebook.com/Archiveshembag"  target="_blank" rel="noopener noreferrer"><i className="bi bi-facebook"></i></a>
        <a href="https://www.instagram.com/jesuitmaduraiarchives/" target="_blank" rel="noopener noreferrer"><i className="bi bi-instagram"></i></a>
        <a href="https://www.youtube.com/@jesuitmaduraiprovincearchi1594" target="_blank" rel="noopener noreferrer"><i className="bi bi-youtube"></i></a>
        {/*<a href=""><i className="bi bi-linkedin"></i></a>*/}
      </div>
      <div className="container">
        <div className="copyright">
          <span>Copyright</span> <strong className="px-1 sitename">Idntica.com</strong> <span>All Rights Reserved</span>
        </div>
        <div className="credits">
          
             </div>
      </div>
    </div>
  </footer>
   <a href="#" id="scroll-top" className="scroll-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>
   
    </div>
  )
}
